import { AxiosInstance } from "axios";
import { DeepReadonly } from "vue";
import { CartItem, CartRewards } from "../types";

export interface StockAvailability {
  tooLargeReservationIds: number[];
  // Gifts can run out while shopping, so every check returns the current ones.
  cartRewards?: CartRewards;
}

export class StocksApi {
  constructor(private axios: AxiosInstance) {}

  checkAvailability(
    cartItems: DeepReadonly<CartItem[]>,
    additionalParams?: Record<string, unknown>
  ): Promise<StockAvailability> {
    return this.axios
      .post<StockAvailability>(`/stocks/availability`, {
        ...additionalParams,
        cart: cartItems.map((i) => ({
          productId: i.product.id,
          quantity: i.quantity,
        })),
      })
      .then((r) => r.data);
  }
}
